import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const SiteSettingsContext = createContext({ settings: null, refresh: () => {} });

const DEFAULTS = {
    tagline: "",
    heroImageUrl: "",
    heroHeadline: "Timeless Elegance, Woven for You",
    heroCtaText: "Shop Sarees",
    heroCtaUrl: "/category/sarees",
    whatsappNumber: "+91 00000 00000",
};

export function SiteSettingsProvider({ children }) {
    const [settings, setSettings] = useState(DEFAULTS);

    const refresh = useCallback(async () => {
        try {
            const { data } = await api.get("/site-settings");
            setSettings({ ...DEFAULTS, ...(data || {}) });
        } catch (_e) {
            setSettings(DEFAULTS);
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    return (
        <SiteSettingsContext.Provider value={{ settings, refresh }}>
            {children}
        </SiteSettingsContext.Provider>
    );
}

export function useSiteSettings() {
    return useContext(SiteSettingsContext);
}
